export class ICDDiagnose {
    icdCode: string;
    icdName: string;
    icdIsActive: boolean;
    icdComment: string;
    icdMidOfficeDiagnoseId: string;
}